// Central source of truth for pricing plans + limits.
// Landing (both pricing sections), dashboard and future Stripe/billing logic
// must read from here. Do NOT duplicate plan data or limits elsewhere.

export const TRIAL = {
  days: 7,
  properties: 1,
  photosPerProperty: 10,
  aiGenerations: 10,
  conciergeMessages: 30,
};

export const CTA_PRIMARY = "Inizia gratis per 7 giorni";
export const CTA_SECONDARY = "Scopri come funziona";
export const TRIAL_MICROCOPY = "7 giorni di prova gratuita";

export const planSignupPath = (id) => `/signup?plan=${id}`;

export const PLANS = [
  {
    id: "trial",
    name: "Prova gratuita",
    badge: null,
    recommended: false,
    isTrial: true,
    headline: "Scopri cosa può fare la tua guida.",
    description:
      "Crea la tua prima struttura, personalizza la guida e prova le funzionalità principali prima di scegliere un piano.",
    price: { monthly: 0, annual: 0 },
    priceLabel: { monthly: "€0", annual: "€0" },
    priceSuffix: "per 7 giorni",
    limits: { durationDays: 7, properties: 1, photosPerProperty: 10, aiGenerations: 10, conciergeMessages: 30 },
    cta: "Prova gratis per 7 giorni",
    ctaCompact: "Prova gratis",
    ctaNote: "Nessun impegno.",
    features: [
      "1 struttura",
      "Guest Guide completa",
      "Link pubblico",
      "QR code",
      "Sezioni personalizzabili",
      "Fino a 10 foto",
      "10 generazioni di contenuti con AI",
      "30 messaggi AI Concierge",
      "Guida locale",
      "Anteprima ospite",
      "Aggiornamenti in tempo reale",
    ],
    limitations: [
      "Branding della piattaforma presente",
      "Nessun branding avanzato",
      "Nessuna traduzione AI",
      "Analytics avanzati non disponibili",
      "Massimo 1 struttura",
    ],
    compact: { tagline: "€0 · 7 giorni", highlights: "1 struttura · Guest Guide · QR · AI limitata" },
  },
  {
    id: "pro",
    name: "Pro",
    badge: "Più scelto",
    recommended: true,
    headline: "Fai lavorare la guida per te.",
    description:
      "Per host che vogliono offrire un'esperienza professionale e ridurre le domande ripetitive degli ospiti.",
    price: { monthly: 9.9, annual: 99 },
    priceLabel: { monthly: "€9,90", annual: "€99" },
    limits: { properties: 3, photosPerProperty: 50, conciergeMessagesMonthly: 500 },
    cta: "Scegli Pro",
    ctaCompact: "Scegli Pro",
    ctaNote: null,
    billingNote: { monthly: "Fatturazione mensile. Puoi annullare quando vuoi.", annual: "€99 fatturati annualmente." },
    features: [
      "Fino a 3 strutture",
      "Tutto ciò che è disponibile nella prova",
      "Fino a 50 foto per struttura",
      "Generazione contenuti AI",
      "Miglioramento testi AI",
      "Traduzioni AI",
      "AI Concierge",
      "500 messaggi AI Concierge/mese",
      "Logo struttura",
      "Branding personalizzato",
      "Analytics",
      "Rimozione branding piattaforma",
    ],
    limitations: [],
    compact: { tagline: "€9,90/mese", highlights: "3 strutture · AI Concierge · Traduzioni · Branding · Analytics" },
  },
  {
    id: "business",
    name: "Business",
    badge: null,
    recommended: false,
    headline: "Più strutture. Un unico posto.",
    description:
      "Per host professionali e property manager che gestiscono più strutture.",
    price: { monthly: 24.9, annual: 249 },
    priceLabel: { monthly: "€24,90", annual: "€249" },
    limits: { properties: 10, photosPerProperty: 100, conciergeMessagesMonthly: 2000 },
    cta: "Scegli Business",
    ctaCompact: "Scegli Business",
    ctaNote: null,
    billingNote: { monthly: "Fatturazione mensile. Puoi annullare quando vuoi.", annual: "€249 fatturati annualmente." },
    features: [
      "Tutto ciò che è disponibile in Pro",
      "Fino a 10 strutture",
      "Fino a 100 foto per struttura",
      "2.000 messaggi AI Concierge/mese",
      "Gestione centralizzata",
      "Analytics avanzati",
      "Supporto prioritario",
    ],
    limitations: [],
    compact: { tagline: "€24,90/mese", highlights: "10 strutture · Più AI · Analytics avanzati · Supporto prioritario" },
  },
];

export const getPlan = (id) => PLANS.find((p) => p.id === id);

// Stripe price lookup_key for a plan + billing cycle (matches backend setup_stripe.py).
export const planLookup = (id, billing) => `${id}_${billing === "annual" ? "annual" : "monthly"}`;
